// extracted by mini-css-extract-plugin
module.exports = {"pageTitleWrapper":"PageTitle_pageTitleWrapper__wiDOk"};